export default "__VITE_ASSET__Dzi3$nFZ__"